import weeklyCalendarContainer from '../weeklyCalendar/WeeklyCalendarContainer';
import RulesComponent from '../rules/RulesComponent'
import { RulesContainer } from '../rules'
import TimeTableContainer from '../timeTable/TimeTableContainer'

export const getRulesStepperJsonArray = (i18n) => {
    const rulesStepperJsonArray = [
        {
            id: 0,
            displayName: i18n.rules.bellTimes,
            container: weeklyCalendarContainer
        },
        {
            id: 1,
            displayName: i18n.rules.timeTableRules,
            container: RulesContainer
        },
        {
            id: 2,
            displayName: i18n.rules.timeTable,
            container: TimeTableContainer
        },

    ];
    return rulesStepperJsonArray
}